var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#08AA15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5633 15.8008C31.0875 16.2501 31.1482 17.0392 30.6989 17.5634C28.0461 20.653 25.3552 23.7426 22.3761 26.5231C21.5683 27.277 20.4483 28.4999 19.2498 28.4999C18.3923 28.4999 17.6351 27.9506 17.0155 27.4119C15.556 26.1427 14.3321 24.5436 13.2262 22.9673C12.8303 22.4018 12.9674 21.6217 13.533 21.2258C14.0985 20.83 14.8778 20.9675 15.2738 21.5329L15.2752 21.535C16.2655 22.942 17.3509 24.3905 18.656 25.5254C18.8742 25.7152 19.0542 25.8479 19.1922 25.9308C19.7281 25.5799 20.2039 25.1308 20.6704 24.6954C23.5819 21.978 26.205 18.9537 28.8005 15.9367C29.2497 15.4126 30.0391 15.3515 30.5633 15.8008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/checkedCircle.979595b4520e65fc19fa8be3df2ab3f0.svg";
export { ForwardRef as ReactComponent };